import type {
  IdpActivityProperties,
  IdpPlanProperties,
} from '@/constants/analytics';
import { usePlanShow } from '@/data/idp/plans';
import {
  ActivityStatus,
  type Activity,
  type Plan,
} from '@/data/idp/plans/interfaces';

export const buildIdpPlanProperties = (
  plan?: Plan | null
): IdpPlanProperties => {
  if (!plan) return {};

  return {
    plan_id: plan.id,
    plan_status: plan.status,
    creation_mode: plan.profile_based_recommendation ? 'ai' : 'manual',
    duration_months: plan.duration_in_months,
    activities_count: plan.activities?.length,
    activities_completed: plan.activities?.filter(
      (activity) => activity.status === ActivityStatus.Completed
    ).length,
  };
};

export const buildIdpActivityProperties = (
  plan: Plan | null | undefined,
  activity: Activity
): IdpActivityProperties => ({
  ...buildIdpPlanProperties(plan),
  plan_id: activity.plan_id,
  activity_type: activity.type,
  generated_by_ai: Boolean(activity.recommended_activity),
});

export const useIdpPlan = (planId?: string) => usePlanShow(planId ?? '').plan;
